import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "posCreditBasketAmendModal" */ './POSCreditBasketAmendModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'POSCreditBasketAmendModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as POSCreditBasketAmendModal };
